import { useEffect } from 'react';
import { useMascot } from '../../context/MascotContext';
import { useLocation } from 'react-router-dom';

const MascotLayer = () => {
    const location = useLocation();

    // Suppress unused variable warnings for future use
    useMascot();

    useEffect(() => {
        // Placeholder for future mouse tracking
    }, []);

    // Hide global mascot on playground
    if (location.pathname === '/neo-playground') return null;

    // TEMPORARY: Hide Neo globally until character design is finalized
    return null;

    /*
    return (
        <div className="fixed inset-0 z-50 pointer-events-none overflow-hidden">
            {/* Neo Container - Fixed position for now (Bottom Right for Idle) * /}
            <motion.div
                className="absolute bottom-10 right-10"
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1, duration: 1 }}
            >
                {/* Pass state and mouse position to Neo * /}
                <NeoCharacter
                    state={mascotState}
                    mouseX={mousePos.x}
                    mouseY={mousePos.y}
                    holdingItem={mascotState === 'snatching' ? 'temp' : null}
                />
            </motion.div>
        </div>
    );
    */
};

export default MascotLayer;
